<template>
  <div>
      <meta-centro-custo-filter v-show="showFilter || ! hasCentroCusto" @filtroAplicado="filter">
      </meta-centro-custo-filter>
    <template v-loading="isLoading" v-if="hasCentroCusto" v-show="!showFilter" class="mt-2">
      <el-row>
        <el-col :span="4">
          <el-card class="mr-2">
            <div slot="header" class="clearfix">
              <strong>Grupos</strong>
            </div>
            <ul class="list-group">
              <li v-bind:class="{ 'indicador-active': indicador.id === indicadorSelected.id }"
                  class="list-group-item clickable" v-for="indicador in parents" @click="onChangeGrupo(indicador)">
                <span style="font-size: .8em ; font-weight: bold"> {{indicador.indicador_nome}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <transition name="fade" mode="out-in">
          <el-col v-loading="isLoading" :span="20" v-if="indicadorSelected">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <el-button-group class="pull-right">
                  <el-tooltip v-if="canChange"  content="Copiar Configurações para outros Centros de Custos (Somente salvos)"
                              placement="top">
                    <el-button size="mini" type="warning" @click="copyShow = true" icon="fa fa-copy"
                               class="mr-2"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canChange"  content="Restaurar pesos para a Origem [Árvore]" placement="top">
                    <el-button size="mini" type="danger" @click="confirmarRestaurarPesos" icon="fa  fa-undo"
                               class="mr-2"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canChange"  content="Salvar" placement="top">
                    <el-button size="mini" type="success" @click="salvar" icon="fa fa-floppy-o"
                               class="mr-2"></el-button>
                  </el-tooltip>
                  <filter-button style="font-size: 2em" :showfilter.sync="showFilter" class="pull-right"></filter-button>
                </el-button-group>
              </div>
              <table  v-show="!showFilter" class="table table-striped table-bordered table-sm" v-if="listIndicadores.length">
                <thead class="thead-dark">
                <tr>
                  <th class="text-center">Indicador</th>
                  <th class="text-center">Peso Orig</th>
                  <th class="text-center">Peso</th>
                  <th class="text-center" v-show="isGrupoRaiz">Partida</th>
                  <th class="text-center">Meta</th>
                  <th class="text-center" v-show="isGrupoRaiz">Desafio</th>
                  <th class="text-center">#</th>
                </tr>
                </thead>
                <tr v-for="item in listChildrens" key="item.indicador_id">
                  <td style="font-size: .8em ; font-weight: bold">{{item.indicador_nome}}</td>
                  <td class="text-right">
                    <el-input-number :disabled="true" v-model="item.peso_periodo" :controls="false"
                                     size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-input-number v-model="item.peso" :controls="false" size="small"></el-input-number>
                  </td>
                  <td class="text-right" v-show="isGrupoRaiz">
                    <el-input-number v-model="item.partida" :controls="false" size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-input-number v-model="item.valor" :controls="false" size="small"></el-input-number>
                  </td>
                  <td class="text-right" v-show="isGrupoRaiz">
                    <el-input-number v-model="item.desafio" :controls="false" size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-switch v-model="item.ativo"></el-switch>
                  </td>
                </tr>
                <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    <strong>{{somaDoPesos}}</strong>
                  </td>
                  <td colspan="4"></td>
                </tr>
                </tbody>
              </table>
            </el-card>
          </el-col>
        </transition>
      </el-row>
    </template>

  </div>

</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {MessageBox, Notification} from 'element-ui'
  import {openAside} from "../../domain/utils";
  import MetaCopy from "./MetaCopy"
  import FilterButton from "@/components/shared/FilterButton";
  import MetaCentroCustoFilter from "./MetaCentroCustoFilter";

  export default {
    name: "CompetenciaMeta",
    components: {MetaCentroCustoFilter, FilterButton, MetaCopy},
    props: [ 'competencia' , 'canChange'],
    data() {
      return {
        showFilter: false,
        copyShow: false,
        listChildrens: [],
        isLoading: false,
        indicadorSelected: {},
        indicadorRaiz: {indicador_id: null, indicador_nome: 'Raiz'},
        centroCusto: {},
        metas: [],
        indicadores_ordem: {},
        event  : {}
      }
    },
    computed: {
      ...mapState(['centroCustoSelected', 'anoSelected', 'mesSelected', 'filterUpdatedAt']),
      hasCentroCusto() {
        return this.centroCusto.hasOwnProperty('id')
      },
      parents() {
        const parentsIds = collect(this.metas).where('ativo', true).pluck('parent_id').all()
        const raiz = {indicador_id: null, indicador_nome: 'Raiz'}
        return collect(this.metas).whereIn('indicador_id', parentsIds).prepend(raiz).all();
      },
      childrens() {
        return collect(this.metas).filter(function (value, key) {
          return value.parent_id != null;
        }).all();
      },
      isGrupoRaiz() {
        return this.indicadorRaiz.id === this.indicadorSelected.id
      },
      listIndicadores() {
        return collect(this.metas).where('parent_id', this.indicadorSelected.indicador_id).all()
      },
      somaDoPesos() {
        const total = collect(this.listChildrens).where('ativo', true).sum('peso')
        return _.isNumber(total) ? total.toFixed(2) : 0
      },
      competenciaLabel() {
        return `${this.anoSelected}/${this.mesSelected}`
      }
    },
    methods: {
      ...mapActions('Competencia', ['restaurarPesos', 'atualizarMetas']),
      onChangeGrupo(indicador) {
        this.indicadorSelected = {...indicador}
        let {indicador_id} = this.indicadorSelected
        indicador_id = !indicador_id ? '' : indicador_id
        let ordemParent = collect(this.indicadores_ordem).get(indicador_id)
        this.listChildrens = collect(this.metas)
          .where('parent_id', this.indicadorSelected.indicador_id)
          .sortBy(function (meta, key) {
            return collect(ordemParent).search(meta.indicador_id)
          }).all()
      },
      async salvar() {
        try {
          await  MessageBox.confirm("Deseja atualizar os dados?", "ATENÇÃO", {type: 'warning'})
          const keysValid = ['ativo', 'indicador_id', 'peso', 'valor', 'desafio', 'partida', 'centro_custo_id', 'id']
          let {indicador_id} = this.indicadorSelected
          indicador_id = indicador_id == null ? 0 : indicador_id
          const metas = {... this.listChildrens.map(item => _.pick(item, keysValid))}
          this.isLoading = true
          await this.atualizarMetas({metas})
          this.isLoading = false
          Notification.success("Metas atualizadas com sucesso.")
          await this.filter({ ...this.event})
          this.onChangeGrupo(this.indicadorSelected)
        } catch (error) {
          this.isLoading = false
          console.log(error)
          Notification.info("Atualização Cancelada.")
        }
      },
      async confirmarRestaurarPesos() {
        try {
          await  MessageBox.confirm("Deseja restaurar os PESOS?", "ATENÇÃO", {type: 'warning'})
          this.isLoading = true
          let {indicador_id} = this.indicadorSelected
          indicador_id = indicador_id === null ? 0 : indicador_id
          await this.restaurarPesos({centroCustoId: this.centroCusto.id, parentId: indicador_id})
          Notification.success("Pesos Restaurados com sucesso")
          await this.filter({ ...this.event})
        } catch (error) {
          Notification.error("Restauração Cancelada.")
        } finally {
          this.isLoading = false
        }
      },
      async filter(event) {

        this.event = {
          ano: this.competencia.ano,
          mes: this.competencia.mes,
          centro_custo_id: event.centro_custo_id
        }
        try {

          this.isLoading = true
          const url = `${process.env.API_PATH}/competencia/ano/${this.event.ano}/mes/${this.event.mes}/centrocusto/${this.event.centro_custo_id}/meta`
          const {data} = await axios.get(url)
          this.centroCusto = {...data.centroCusto}
          this.metas = [...data.metas]
          this.indicadores_ordem = {...data.indicadores_ordem}
          if (this.metas.length > 0) {
            this.onChangeGrupo(this.parents[0])
          }
          this.showFilter = false
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      if (!this.centroCustoSelected ) {
        return
      }
      this.event = {
        ano: this.competencia.ano,
        mes: this.competencia.mes,
        centro_custo_id: this.centroCustoSelected
      }
      await this.filter({... this.event })
      this.onChangeGrupo({...this.indicadorRaiz})
    }
  }
</script>
<style scoped>
  .indicador-active {
    background-color: #9933CC;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/MetaCentroCusto.vue